import { publishAssets } from '@/features/instruments/publish/shared/lib/publishAssets'
import {
  publishPreviewPushLabelColor,
  publishPreviewSectionTitleColor,
  publishPrimary,
} from '@/features/instruments/publish/shared/lib/publishFigmaTokens'
import type { DistributionChannelId } from './distributionChannelTypes'

export interface DistributionChannelDef {
  id: DistributionChannelId
  title: string
  description: string
  testId: string
  /** 44×44 composite icon well (Figma export) */
  iconUrlUnselected: string
  iconUrlSelected: string
  badgeUrlUnselected: string
  badgeUrlSelected: string
  /** Notification preview row — 14×14 label icon */
  previewIconUrl: string
  previewLabelColor: string
  previewHeading: string
}

export const DISTRIBUTION_CHANNELS: DistributionChannelDef[] = [
  {
    id: 'push',
    title: 'In-app Push',
    description: "Push notification sent to Signal Provider's mobile app",
    testId: 'distribution-channel-push',
    iconUrlUnselected: publishAssets.channelPushUnselectedUrl,
    iconUrlSelected: publishAssets.channelPushSelectedUrl,
    badgeUrlUnselected: publishAssets.channelUnselectedBadgeUrl,
    badgeUrlSelected: publishAssets.channelSelectedBadgeUrl,
    previewIconUrl: publishAssets.channelPushIconUrl,
    previewLabelColor: publishPreviewPushLabelColor,
    previewHeading: 'Push Preview',
  },
  {
    id: 'email',
    title: 'Email',
    description: "Email notification sent to Signal Provider's registered email address",
    testId: 'distribution-channel-email',
    iconUrlUnselected: publishAssets.channelEmailUnselectedUrl,
    iconUrlSelected: publishAssets.channelEmailSelectedUrl,
    badgeUrlUnselected: publishAssets.channelUnselectedBadgeUrl,
    badgeUrlSelected: publishAssets.channelSelectedBadgeUrl,
    previewIconUrl: publishAssets.channelEmailIconUrl,
    previewLabelColor: publishPreviewSectionTitleColor,
    previewHeading: 'Email Preview',
  },
  {
    id: 'sms',
    title: 'SMS',
    description: "Text message sent to Signal Provider's registered mobile number",
    testId: 'distribution-channel-sms',
    iconUrlUnselected: publishAssets.channelSmsUnselectedUrl,
    iconUrlSelected: publishAssets.channelSmsSelectedUrl,
    badgeUrlUnselected: publishAssets.channelUnselectedBadgeUrl,
    badgeUrlSelected: publishAssets.channelSelectedBadgeUrl,
    previewIconUrl: publishAssets.channelSmsIconUrl,
    previewLabelColor: publishPrimary,
    previewHeading: 'SMS Preview',
  },
]

export const DISTRIBUTION_CHANNEL_BY_ID = Object.fromEntries(
  DISTRIBUTION_CHANNELS.map((channel) => [channel.id, channel]),
) as Record<DistributionChannelId, DistributionChannelDef>

export const DEFAULT_SELECTED_CHANNELS: DistributionChannelId[] = ['push']
